var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGitlab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E24329;}\r\n\t.st1{fill:#FC6D26;}\r\n\t.st2{fill:#FCA326;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wm_no_bg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    className: "st0",
    d: "M65,70l10-30.8H55.1L65,70z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    className: "st1",
    d: "M65,70L55,39.2H41L65,70L65,70z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-18",
    className: "st2",
    d: "M41,39.2l-3.1,9.4c-0.3,0.9,0,1.8,0.8,2.3L65,70L41,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-20",
    className: "st0",
    d: "M41,39.2h14l-6-18.5c-0.3-0.9-1.7-0.9-1.9,0L41,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    className: "st1",
    d: "M65,70l10-30.8h14L65,70z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    className: "st2",
    d: "M89,39.2l3.1,9.4c0.3,0.9,0,1.8-0.8,2.3L65,70L89,39.2L89,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-23",
    className: "st0",
    d: "M89,39.2H75l6-18.5c0.3-0.9,1.7-0.9,1.9,0L89,39.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlab);
export default __webpack_public_path__ + "static/media/Gitlab.3089614422571cccb6d6a35ff49461fc.svg";
export { ForwardRef as ReactComponent };